import { kebabCase } from 'lodash';
import { Product, Color } from '@thisisdevelopment/akzonobel-core';
import { EnrichedCombination } from '@thisisdevelopment/akzonobel-core';

// gives a lighter shade of a color
export const lighten = (color: string, percent: number) => {
  const num = parseInt(color.replace('#', ''), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const G = ((num >> 8) & 0x00ff) + amt;
  const B = (num & 0x0000ff) + amt;
  return `#${(
    0x1000000 +
    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
    (B < 255 ? (B < 1 ? 0 : B) : 255)
  )
    .toString(16)
    .slice(1)}`;
};

// gives a darker shade of a color
export const darken = (color: string, percent: number) => {
  const num = parseInt(color.replace('#', ''), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) - amt;
  const G = ((num >> 8) & 0x00ff) - amt;
  const B = (num & 0x0000ff) - amt;
  return `#${(
    0x1000000 +
    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
    (B < 255 ? (B < 1 ? 0 : B) : 255)
  )
    .toString(16)
    .slice(1)}`;
};

export const isProduction = process.env.NODE_ENV === 'production';
export const isDevelopment = process.env.NODE_ENV === 'development';

export function calculatePaintSurface(packSize: string, spreadingRate: number): number {
  const match = packSize
    .trim()
    .toUpperCase()
    .match(/^([\d.]+)\s*(L|ML)$/);
  if (!match) throw new Error('Invalid packSize format');
  const size = match[1];
  const unit = match[2];
  const sizeInLiters = unit.toUpperCase() === 'ML' ? parseFloat(size) / 1000 : parseFloat(size);
  return sizeInLiters * spreadingRate;
}

export const getProductType = (product: Product) =>
  product.sheen === 'Matt' ? 'Velvet Matt' : product.sheen;

export const packSizeToLiters = (packSize: string) => {
  const match = packSize
    .trim()
    .toUpperCase()
    .match(/^([\d.]+)\s*(L|ML)$/);
  if (!match) return Number.POSITIVE_INFINITY;
  const [, size, unit] = match;
  return unit === 'ML' ? parseFloat(size) / 1000 : parseFloat(size);
};

export const getColorUrl = (color: Color | EnrichedCombination) => {
  const uriFriendlyName =
    'uriFriendlyName' in color && color.uriFriendlyName
      ? color.uriFriendlyName
      : kebabCase(color.defaultColorName);
  return `/en/colours/${color.colorCollectionColorId}/${uriFriendlyName}`;
};
